enum MessageRole {
  Developer = "developer",
  UserContext = "user_context",
  User = "user",
  Assistant = "assistant",
  Tool = "tool",
}
export default MessageRole;
